
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { ExamsByCode } from '../templates/exams-config/ExamsByCode.class';

@Injectable({
  providedIn: 'root'
})
export class ShowExamnsTemplateContainerService {
  examsByCode = new ExamsByCode().data;


  private examDataSubject = new BehaviorSubject({});
  examData = this.examDataSubject.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  /**
   * Este método tiene como objetivo actualizar el observable que
   * contiene la información del examen que se va a cargar
   * @param data
   */
  updateDataExam(data: any): void {
    // console.log('EXAMEN SERVICE LE LLEGO: ', data);
    this.examDataSubject.next(data);
  }

  /**
   * Método encargado de obtener los motivos de cierre desde al API
   */
  getSingleExamenData(id: number, examenCode: string): Observable<any> {
    const url = this.examsByCode[examenCode].dataUrl;
    const examenDataURL = this.buildUrlApi(url, examenCode, id);
    return this.http.get<any>(examenDataURL);
  }

  /**
   * Este método tiene como fin construir
   * dinamicamente la URL para consumir el API
   * @param method
   */
  private buildUrlApi(method: string, examenCode: string, id: number): string {
    return `${environment.apiUrl}` + method + examenCode + '/' + id;
  }

}
